import { Injectable } from '@angular/core';
import { DispatcherQueue } from './models/dispatcher-queue';

@Injectable({
  providedIn: 'root'
})
export class DispatcherService {
  queues: Record<string, DispatcherQueue> = {};

  getQueue(key: string) {
    if (!this.queues[key]) {
      this.queues[key] = new DispatcherQueue();
    }

    return this.queues[key];
  }
}
